import { createSelector } from 'reselect'
import { ICarrierState } from 'apps/fleet-planner/types'
import { IStore } from 'apps/fleet-planner/utils/types/store'

const selectCarriersState = (state: IStore): ICarrierState => state.carriers

export const selectCarriersList = createSelector(selectCarriersState, ({ carriers }) => carriers)

export const selectCarrierOptionList = createSelector(
  selectCarriersState,
  ({ carriersSelect }) => carriersSelect
)
